import { render, staticRenderFns } from "./smallTitle.vue?vue&type=template&id=b816a4be&scoped=true"
import script from "./smallTitle.vue?vue&type=script&lang=js"
export * from "./smallTitle.vue?vue&type=script&lang=js"
import style0 from "./smallTitle.vue?vue&type=style&index=0&id=b816a4be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b816a4be",
  null
  
)

export default component.exports